module.exports = __webpack_public_path__ + "img/jaoc_pop_results_remakes.51ba1d97.png";